import { useQuery } from "@tanstack/react-query";
import { getUserInfo } from "@repo/next-shared/actions/getUserInfo";

export function useUserInfo() {
  return useQuery({
    queryKey: ["user", "info"],
    queryFn: () => getUserInfo(),
    staleTime: 0,
  });
}
